import React, { useEffect, useState } from 'react';
import swal from 'sweetalert';
import { sitCount } from '../assets/SitCount';
import '../style/SitReservation.css';
const SitReservation = ({ setSelectSit, count }) => {
  function Seat({ isAvailable, isSelected, onSelect }) {
    return (
      <div
        className={`seat ${isAvailable ? 'available' : 'unavailable'} ${
          isSelected ? 'selected' : ''
        }`}
        onClick={onSelect}
      />
    );
  }

  const [seats, setSeats] = useState(sitCount);
  useEffect(() => {
    setSeats(sitCount);
  }, [count]);
  const selectedSit = seats?.filter((item) => item?.isSelected === true);
  const unSelectedSit = seats?.filter((item) => item?.isSelected === false);

  const handleSeatClick = (seatId) => {
    if (count <= selectedSit?.length) {
      var updatedSeats = selectedSit?.map((seat) => {
        if (seat.id === seatId) {
          return {
            ...seat,
            isSelected: !seat.isSelected,
            isAvailable: !seat.isAvailable,
          };
        } else {
          swal('Oops!', `Your Ticket Limit is ${count}`, 'error');
        }
        return seat;
      });

      setSeats([...updatedSeats, ...unSelectedSit]);
    } else {
      updatedSeats = seats?.map((seat) => {
        if (seat.id === seatId) {
          return {
            ...seat,
            isSelected: !seat.isSelected,
            isAvailable: !seat.isAvailable,
          };
        }
        return seat;
      });
      setSeats(updatedSeats);
    }
  };
  useEffect(() => {
    const selectedSeats = seats?.filter((seat) => seat.isSelected);
    setSelectSit(selectedSeats);
  }, [seats]);

  const sortedSeats = seats.slice().sort((a, b) => a.id - b.id);

  console.log(selectedSit?.length);
  return (
    <>
      <div className='movie-container bg-[#242333]'>
        <ul className='showcase pt-5'>
          <li>
            <div className='seat'></div>
            <small>N/A</small>
          </li>
          <li>
            <div className='seat selected'></div>
            <small>Selected</small>
          </li>
          <li>
            <div className='seat occupied'></div>
            <small>Occupied</small>
          </li>
        </ul>

        <div className='container flex justify-center items-center flex-col my-10'>
          <div className='screen'></div>

          <div className='flex items-center content-center'>
            {!sortedSeats &&
              seats?.map((item, index) => (
                <Seat
                  onSelect={() => handleSeatClick(item?.id)}
                  key={item?.id}
                  isAvailable={item?.isAvailable}
                  isSelected={item?.isSelected}
                />
              ))}
            {sortedSeats &&
              sortedSeats?.map((item, index) => (
                <Seat
                  onSelect={() => handleSeatClick(item?.id)}
                  key={index}
                  isAvailable={item?.isAvailable}
                  isSelected={item?.isSelected}
                />
              ))}
          </div>

          {/* <div className='flex items-center content-center'>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat occupied'></div>
            <div className='seat occupied'></div>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat'></div>
          </div>
          <div className='flex items-center content-center'>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat occupied'></div>
            <div className='seat occupied'></div>
          </div>
          <div className='flex items-center content-center'>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat'></div>
          </div>
          <div className='flex items-center content-center'>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat occupied'></div>
            <div className='seat occupied'></div>
            <div className='seat'></div>
            <div className='seat'></div>
            <div className='seat'></div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default SitReservation;
